// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Earth Shield",
  id: "earth-shield",
  metadata: {
    aspect: SavedSpellAspect.Earth,
    imports: ["earth","wait"],
    icon: {
      "backgroundColor": 3282208,
      "layers": [
        {
          "iconKey": "earthSpike",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": 0,
          "color": 14986322
        },
        {
          "iconKey": "delay",
          "position": {
            "x": 15,
            "y": -2
          },
          "scale": 0.63,
          "rotation": 7,
          "color": 16118015
        }
      ]
    },
  },
};

export default metadata;
